import axios from '@/plugins/axios'

export default {
  fetch(params) {
    return axios.get('users', { params }).then(result => result.data)
  },
  store(data) {
    return axios.post('users', data).then(result => result.data)
  },
  update(userId, data) {
    return axios.patch(`users/${userId}`, data).then(result => result.data)
  },
  get(userId) {
    return axios.get(`users/${userId}`).then(result => result.data)
  },
  delete(id) {
    return axios.delete(`users/${id}`).then(result => result.data)
  }
}
